// src/com/trans_plan_seal_check_info/TransPlanSealCheckInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN_SEAL_CHECK_INFO Apollo Graphql
 * 화물인계 및 확인
 * Project: NewTOP for cloud
 * 2025-11-26 16:59:01 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */


/*


extend type Mutation {
	transPlanSealCheckInfoTakeAtStore(transPlanSealCheckInfo: InputTransPlanSealCheckInfo!): CommonResponse!
}


input InputTransPlanSealCheckInfo {
	planId: String!
}



*/

export const TAKE_AT_STORE_TRANS_PLAN_SEAL_CHECK_INFO = gql`
mutation TakeAtStoreTransPlanSealCheckInfo($transPlanSealCheckInfo:InputTransPlanSealCheckInfo!) {
    transPlanSealCheckInfoTakeAtStore(transPlanSealCheckInfo: $transPlanSealCheckInfo) {
        ok
        message
    }
}
`;
